import React, { useCallback, useState, useEffect } from "react"
import { MixedTags } from "@yaireo/tagify/dist/react.tagify"
import '@yaireo/tagify/dist/tagify.css';
import {
    MetafieldsMajor,
} from '@shopify/polaris-icons';
import {
    Icon, Popover, ActionList
} from "@shopify/polaris";
import './index.css';

const settings = {
    duplicates: true,
    mode: 'mix',  // <--  Enable mixed-content
    pattern: /@/,  // <- must define "patten" in mixed mode
    dropdown: {
        enabled: 1,
        position: "text"
    },
}
const MixedModeTagify = (props) => {
    const {
        id,
        tagInputData,
        isShowSelectPop,
        actionList,
        tagActive,
        changeSelectPop,
        defaultTag,
        addTags,

    } = props;
    const [defaultTags, setDefaultTags] = useState('');

    // 打开选择项
    const openSelectPopver = (id) => {
        changeSelectPop(id);
    }

    // 监听改变
    const onTagChange = useCallback(e => {
        let value = "";
        if (e.type === "change") {
            value = (e.detail.value).replace(/[\n\u200B]/g, "");
            if(Boolean(value) && value === defaultTag.replace(/[\n\u200B]/g, "")) {
                return false;
            }
            // console.log("CHANGED-change:", e.detail.value)
            setDefaultTags(e.detail.value)
            tagInputData(e)
        } else if (e.type === "remove") {
            value = (e.detail.tagify.state.lastOriginalValueReported).replace(/[\n\u200B]/g, "");
            // console.log("CHANGED-remove:", value)
            tagInputData(e)
        } else {
            value = (e.detail.textContent).replace(/[\n\u200B]/g, "");
            // console.log("CHANGED-input:", value)
            tagInputData(e)
        }
    }, [])

    // 禁止Enter键换行
    const closeKeyEnter = (e) => {
        if (e.keyCode === 13) {
            if (e?.preventDefault) {
                e.preventDefault();
            } else {
                e.returnValue = false;
            }
        }
    }

    useEffect(() => {
        setDefaultTags(defaultTag);
        window.addEventListener('keydown', closeKeyEnter, true);
    }, [])

    useEffect(() => {
        if(Boolean(addTags)) {
            setDefaultTags(addTags);
        }
    }, [addTags])

    return (
        <div className={`free_tag_input ${Boolean(tagActive) && (tagActive.length > 0 && tagActive.includes(id)) ? 'tagActive' : ''}`} id={`${id}_Input`}>
            <MixedTags
                settings={settings}
                className={id}
                onInput={onTagChange}
                onChange={onTagChange}
                onRemove={onTagChange}
                value={defaultTags}
            />
            <div className={`free_suffix`}>
                <Popover
                    active={isShowSelectPop}
                    activator={
                        <div className="suffix_meta" onClick={() => openSelectPopver(id)}>
                            <Icon source={MetafieldsMajor} color="base" />
                        </div>
                    }
                    autofocusTarget="first-node"
                    onClose={() => openSelectPopver(id)}
                >
                    <Popover.Pane>
                        <ActionList
                            actionRole="menuitem"
                            items={actionList}
                        />
                    </Popover.Pane>
                </Popover>
            </div>
        </div>
    )
}

export default MixedModeTagify
